import { useEffect } from 'react'
import Styled from 'styled-components'
import { Drawer } from 'antd'
import { State } from '@hookstate/core'
import { useTranslation } from 'react-i18next'
import { getJobChatTokenUseCase } from '../../application/get-job-chat-token.use-case'
import { odinJobRepository } from '../odin-job.repository'
import { odinHeimdallRepository } from '../odin-heimdall.repository'
import { setOfflineParticipantUseCase } from '../../application/set-offline-participant.use-case'

const Chat = Styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`
const Container = Styled.div`
  width: 100%;
  height: 100%;
  & > div > section{
    height: 100%!important;
    & > main > div > div{
      width: 100%!important;
      max-width: 100%!important;
      flex: auto!important;
    }
  }
`
const chatURL = process.env.REACT_APP_CHAT_V3_LIB

const runScript = async (url: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.id = 'chatV3-module'
    script.onload = resolve
    script.onerror = reject
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  })
}

const loadApp = async (
  url: string,
  jobUuid: string,
  currentUserName: string,
  currentUserId: string,
  selectedTab: string,
  token: string
) => {
  await runScript(url)
  const params = {
    job: jobUuid,
    token: token,
    container: '#instaleap-lsw-v3',
    activeTabs: 'chatTab',
    theme: {
      primaryColor: '#000000',
      secondaryColor: '#444fe1'
    },
    backgroundColor: '#ffffff',
    supportChat: {
      enable: true,
      chatMemberId: String(currentUserId),
      chatMemberName: currentUserName,
      tabSelected: selectedTab
    }
  }
  //@ts-ignore
  window.instaleap.chat.render(params)
}

type DrawerChatProps = {
  openModal: State<boolean, {}>
  jobUuid: string
  currentUserId: string
  currentUserName: string
  selectedTab: string
}

const DrawerChat = ({ openModal, jobUuid, currentUserName, currentUserId, selectedTab }: DrawerChatProps) => {
  const { t } = useTranslation()
  const getJobChatTokenUseCaseInteractor = getJobChatTokenUseCase(odinJobRepository)

  const getJobChatToken = async () => {
    const token = await getJobChatTokenUseCaseInteractor()
    return token
  }

  useEffect(() => {
    const fetchChat = async () => {
      const token = await getJobChatToken()
      await loadApp(chatURL, jobUuid, currentUserName, currentUserId, selectedTab, token)
    }
    fetchChat()
    return () => {
      document.getElementById('chatV3-module').remove()
      setOfflineParticipantUseCase(odinHeimdallRepository)(jobUuid, currentUserId)
    }
  }, [openModal])

  return (
    <Chat
      width={500}
      height={'100%'}
      title={t('chat-widget.title')}
      closable={true}
      placement='right'
      visible={openModal.get()}
      onClose={() => openModal.set(false)}
    >
      <Container id='instaleap-lsw-v3'></Container>
    </Chat>
  )
}

export { DrawerChat }
